class SubmitFormLink {
    static attach(triggerSelector) {
        [...document.querySelectorAll(triggerSelector)].forEach((el) => {
            const theForm = el.closest("form");
            const { url } = el.dataset;
            if (url && theForm) {
                el.addEventListener("click", () => {
                    theForm.action = url;
                    theForm.submit();
                });
            }
        });
    }
}

export { SubmitFormLink };
